module.exports = __webpack_public_path__ + "static/media/6.b7671b0a.ogg";